<app-header></app-header>

<ion-content
  *ngIf="(vendorData$ | async) as vendorData"
  id="manage-vendors"
  class="gray-content-bg"
  [ngClass]="
  (platformService?.isTouchExperience$ | async)
    ? platformService?.platformType === platformService?.platformEnum?.tablet
      ? 'tablet'
      : 'mobile'
    : 'desktop'
"
>
  <ion-grid [fixed]="true">
    <!-- DESKTOP  -->
    <ng-container
      *ngIf="(platformService?.isTouchExperience$ | async) === false"
    >
      <app-breadcrumbs [breadcrumbs]="breadcrumbs"></app-breadcrumbs>
      <ion-row class="manage-vendors-header-row">
        <ion-col>
          <ion-label data-cy="manage-vendor-label">
            {{ 'i18n.vendors.manageVendors' | translate | uppercase }}
          </ion-label>
        </ion-col>
        <ion-col>
          <ion-button
            data-cy="create-vendor-button"
            id="create-vendor-btn"
            class="usf-fill-green-button"
            (click)="openCreateNonUsfVendorModal(ListActions.create, vendorData)"
          >
            {{ 'i18n.vendors.addNewVendor' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row
        class="manage-vendors-sorting-row"
        *ngIf="vendorData?.vendors.length > 0"
      >
        <!-- Code -->
        <ion-col
          offset-xl="0.5"
          offset-lg="0.5"
          offset-md="0.65"
          offset-sm="0.65"
          offset-xs="0.65"
          size="0.95"
        >
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'vendorId'"
            (click)="changeSort('vendorId', vendorData)"
            data-cy="click-sort-vendor-id"
          >
            <p class="vendor-code-header" data-cy="vendor-code-label">
              {{ 'i18n.vendors.code' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'vendorId') || (vendorData?.selectedSort?.columnName === 'vendorId' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'vendorId' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'vendorId') || (vendorData?.selectedSort?.columnName === 'vendorId' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'vendorId' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
        <!-- Vendor Name -->
        <ion-col size="2">
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'distributorName'"
            (click)="changeSort('distributorName', vendorData)"
            data-cy="click-sort-vendor-distributor-name"
          >
            <p class="vendor-name-header" data-cy="vendor-name-label">
              {{ 'i18n.vendors.vendorName' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'distributorName') || (vendorData?.selectedSort?.columnName === 'distributorName' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'distributorName' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'distributorName') || (vendorData?.selectedSort?.columnName === 'distributorName' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'distributorName' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
        <!-- Contact Name -->
        <ion-col size="2">
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'contactName'"
            (click)="changeSort('contactName', vendorData)"
            data-cy="click-sort-vendor-contact-name"
          >
            <p class="contact-name-header" data-cy="vendor-contact-name-label">
              {{ 'i18n.vendors.contactName' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'contactName') || (vendorData?.selectedSort?.columnName === 'contactName' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'contactName' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'contactName') || (vendorData?.selectedSort?.columnName === 'contactName' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'contactName' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
        <!-- City/State -->
        <ion-col size="2">
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'city'"
            (click)="changeSort('city', vendorData)"
            data-cy="click-sort-vendor-city"
          >
            <p class="city-state-header" data-cy="vendor-city-label">
              {{ 'i18n.vendors.cityState' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'city') || (vendorData?.selectedSort?.columnName === 'city' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'city' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'city') || (vendorData?.selectedSort?.columnName === 'city' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'city' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
        <!-- Phone -->
        <ion-col size="1.5">
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'telephoneNumber'"
            (click)="changeSort('telephoneNumber', vendorData)"
            data-cy="click-sort-vendor-telephone-number"
          >
            <p class="phone-header" data-cy="vendor-phone-label">
              {{ 'i18n.vendors.phone' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'telephoneNumber') || (vendorData?.selectedSort?.columnName === 'telephoneNumber' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'telephoneNumber' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'telephoneNumber') || (vendorData?.selectedSort?.columnName === 'telephoneNumber' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'telephoneNumber' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
        <!-- Email -->
        <ion-col
          size-xl="3.05"
          size-lg="3.05"
          size-md="2.90"
          size-sm="2.90"
          size-xs="2.90"
        >
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'email'"
            (click)="changeSort('email', vendorData)"
            data-cy="click-sort-vendor-email"
          >
            <p class="email-header" data-cy="vendor-email-label">
              {{ 'i18n.vendors.email' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'email') || (vendorData?.selectedSort?.columnName === 'email' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'email' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'email') || (vendorData?.selectedSort?.columnName === 'email' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'email' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
      </ion-row>
      <ion-row
        *ngFor="let vendor of vendorData?.vendors;"
        class="manage-vendors-card-row"
        [class.is-selected]="vendor?.isSelected"
      >
        <ion-col
          size-xl="0.4"
          size-lg="0.4"
          size-md="0.55"
          size-sm="0.55"
          size-xs="0.55"
          class="vendor-card-checkbox"
        >
          <span
            class="dot"
            (click)="updateSelectedVendors(vendor?.vendorId, vendor?.isSelected)"
            data-cy="click-update-selected-vendors"
          >
            <ion-icon name="checkmark-outline"></ion-icon>
          </span>
        </ion-col>
        <ion-col size="1" class="vendor-card-col-left">
          <p data-cy="vendor-id-text">{{ vendor?.vendorId }}</p>
        </ion-col>
        <ion-col size="2" class="vendor-card-col">
          <p data-cy="vendor-distributor-name-text">
            {{ vendor?.distributorName }}
          </p>
        </ion-col>
        <ion-col size="2" class="vendor-card-col">
          <p data-cy="vendor-contact-name-text">{{ vendor?.contactName }}</p>
        </ion-col>
        <ion-col size="2" class="vendor-card-col">
          <p data-cy="vendor-city-and-state-text">
            {{ vendor?.city }}{{ (!!vendor?.city && !!vendor?.state) ? '/' : ''
            }}{{ vendor?.state }}
          </p>
        </ion-col>
        <ion-col
          size="1.5"
          [ngClass]="(platformService.isTouchExperience$ | async) ? 'vendor-card-col-right' : 'vendor-card-col'"
        >
          <p data-cy="vendor-phone-number-text">
            {{ vendor?.telephoneNumber }}
          </p>
        </ion-col>
        <ion-col
          class="vendor-card-col-right"
          size-xl="3.1"
          size-lg="3.1"
          size-md="2.95"
          size-sm="2.95"
          size-xs="2.95"
        >
          <p class="email" data-cy="vendor-email-text">{{ vendor?.email }}</p>
        </ion-col>
      </ion-row>
    </ng-container>

    <!-- TABLET -->
    <ng-container
      *ngIf="platformService?.platformType === platformService?.platformEnum?.tablet"
    >
      <ion-row class="manage-vendors-header-row">
        <ion-col>
          <ion-label data-cy="manage-vendor-label">
            {{ 'i18n.vendors.manageVendors' | translate | uppercase }}
          </ion-label>
        </ion-col>
        <ion-col>
          <ion-button
            data-cy="create-vendor-btn"
            id="create-vendor-btn"
            class="usf-fill-green-button"
            (click)="openCreateNonUsfVendorModal(ListActions.create, vendorData)"
          >
            {{ 'i18n.vendors.addNewVendor' | translate }}
          </ion-button>
        </ion-col>
      </ion-row>
      <ion-row
        class="manage-vendors-sorting-row"
        *ngIf="vendorData?.vendors.length > 0"
      >
        <!-- Code -->
        <ion-col offset="0.55" size="1">
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'vendorId'"
            (click)="changeSort('vendorId', vendorData)"
            data-cy="click-sort-vendor-id"
          >
            <p class="vendor-code-header" data-cy="vendor-code-header">
              {{ 'i18n.vendors.code' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'vendorId') || (vendorData?.selectedSort?.columnName === 'vendorId' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'vendorId' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'vendorId') || (vendorData?.selectedSort?.columnName === 'vendorId' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'vendorId' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
        <!-- Vendor Name -->
        <ion-col size="2">
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'distributorName'"
            (click)="changeSort('distributorName', vendorData)"
            data-cy="click-sort-vendor-distributor-name"
          >
            <p class="vendor-name-header" data-cy="vendor-name-label">
              {{ 'i18n.vendors.vendorName' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'distributorName') || (vendorData?.selectedSort?.columnName === 'distributorName' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'distributorName' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'distributorName') || (vendorData?.selectedSort?.columnName === 'distributorName' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'distributorName' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
        <!-- Contact Name -->
        <ion-col size="2">
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'contactName'"
            (click)="changeSort('contactName', vendorData)"
            data-cy="click-sort-vendor-contact-name"
          >
            <p class="contact-name-header" data-cy="vendor-contact-label">
              {{ 'i18n.vendors.contactName' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'contactName') || (vendorData?.selectedSort?.columnName === 'contactName' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'contactName' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'contactName') || (vendorData?.selectedSort?.columnName === 'contactName' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'contactName' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
        <!-- City/State -->
        <ion-col size="2">
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'city'"
            (click)="changeSort('city', vendorData)"
            data-cy="click-sort-vendor-city"
          >
            <p class="city-state-header" data-cy="vendor-city-and-state-label">
              {{ 'i18n.vendors.cityState' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'city') || (vendorData?.selectedSort?.columnName === 'city' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'city' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'city') || (vendorData?.selectedSort?.columnName === 'city' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'city' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
        <!-- Phone -->
        <ion-col size="2">
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'telephoneNumber'"
            (click)="changeSort('telephoneNumber', vendorData)"
            data-cy="click-sort-vendor-telephone-number"
          >
            <p class="phone-header" data-cy="vendor-phone-label">
              {{ 'i18n.vendors.phone' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'telephoneNumber') || (vendorData?.selectedSort?.columnName === 'telephoneNumber' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'telephoneNumber' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'telephoneNumber') || (vendorData?.selectedSort?.columnName === 'telephoneNumber' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'telephoneNumber' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
        <ion-col size="2.45">
          <div
            class="vendor-sorting-option"
            [class.sort-active]="vendorData?.selectedSort?.columnName === 'email'"
            (click)="changeSort('email', vendorData)"
            data-cy="click-sort-vendor-email"
          >
            <p class="email-header" data-cy="vendor-email-label">
              {{ 'i18n.vendors.email' | translate }}
            </p>
            <div class="caret-icon">
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'email') || (vendorData?.selectedSort?.columnName === 'email' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'email' && vendorData?.selectedSort?.sortDirection === SortingDirection.desc"
                name="caret-up-outline"
              ></ion-icon>
              <ion-icon
                *ngIf="(vendorData?.selectedSort?.columnName !== 'email') || (vendorData?.selectedSort?.columnName === 'email' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc)"
                [class.is-sorted]="vendorData?.selectedSort?.columnName === 'email' && vendorData?.selectedSort?.sortDirection === SortingDirection.asc"
                name="caret-down-outline"
              ></ion-icon>
            </div>
          </div>
        </ion-col>
      </ion-row>
      <!-- VENDOR CARD -->
      <ion-row
        *ngFor="let vendor of vendorData?.vendors;"
        class="manage-vendors-card-row"
        [class.is-selected]="vendor?.isSelected"
      >
        <ion-col size="0.55" class="vendor-card-checkbox">
          <span
            class="dot"
            (click)="updateSelectedVendors(vendor?.vendorId, vendor?.isSelected)"
            data-cy="click-update-selected-vendors"
          >
            <ion-icon name="checkmark-outline"></ion-icon>
          </span>
        </ion-col>
        <ion-col size="11.45" class="info-container">
          <ion-row>
            <ion-col
              size="1"
              class="vendor-card-col-left"
              data-cy="vendor-id-text"
            >
              <p>{{ vendor?.vendorId }}</p>
            </ion-col>
            <ion-col
              size="2.1"
              class="vendor-card-col"
              data-cy="vendor-distributor-name-text"
            >
              <p>{{ vendor?.distributorName }}</p>
            </ion-col>
            <ion-col
              size="2.1"
              class="vendor-card-col"
              data-cy="vendor-contact-name-text"
            >
              <p>{{ vendor?.contactName }}</p>
            </ion-col>
            <ion-col
              size="2.1"
              class="vendor-card-col"
              data-cy="vendor-city-and-state-text"
            >
              <p>
                {{ vendor?.city }}{{ (!!vendor?.city && !!vendor?.state) ? '/' :
                '' }}{{ vendor?.state }}
              </p>
            </ion-col>
            <ion-col
              size="2.1"
              class="vendor-card-col"
              data-cy="vendor-phone-number-text"
            >
              <p>{{ vendor?.telephoneNumber }}</p>
            </ion-col>
            <ion-col class="vendor-card-col-right" size="2.5">
              <p class="email" data-cy="vendor-email-text">
                {{ vendor?.email }}
              </p>
            </ion-col>
          </ion-row>
        </ion-col>
      </ion-row>
    </ng-container>

    <!-- MOBILE -->
    <ng-container
      *ngIf="platformService?.platformType === platformService?.platformEnum?.mobile"
    >
      <ion-row class="manage-vendors-header-row" data-cy="manage-vendor-label">
        <ion-label>
          {{ 'i18n.vendors.manageVendors' | translate | uppercase }}
        </ion-label>
        <div *ngIf="vendorData?.vendors.length > 0">
          <ion-button
            data-cy="sort-vendors-btn"
            id="sort-vendors-btn"
            class="usf-outline-green-button"
            (click)="openMobileSort(vendorData)"
            data-cy="click-sort-vendor-id"
          >
            {{ 'i18n.common.sort' | translate }}
          </ion-button>
        </div>
      </ion-row>
      <ion-row
        *ngFor="let vendor of vendorData?.vendors"
        class="manage-vendors-card-row"
        [class.is-selected]="vendor?.isSelected"
      >
        <ion-col size="1.25" class="vendor-card-checkbox">
          <span
            class="dot"
            (click)="updateSelectedVendors(vendor?.vendorId, vendor?.isSelected)"
          >
            <ion-icon name="checkmark-outline"></ion-icon>
          </span>
        </ion-col>
        <ion-col size="5.375" class="vendor-card-col-left">
          <div class="vendor-card-col-content">
            <p data-cy="vendor-distributor-name-text">
              {{ vendor?.distributorName }}
            </p>
            <p *ngIf="vendor?.contactName" data-cy="vendor-contact-name-text">
              {{ vendor?.contactName }}
            </p>
            <p
              *ngIf="vendor?.city || vendor?.state"
              data-cy="vendor-city-and-state-text"
            >
              {{ vendor?.city }}{{ (!!vendor?.city && !!vendor?.state) ? '/' :
              '' }}{{ vendor?.state }}
            </p>
          </div>
        </ion-col>
        <ion-col size="5.375" class="vendor-card-col-right">
          <div class="vendor-card-col-content">
            <p data-cy="vendor-id-text">{{ vendor?.vendorId }}</p>
            <p
              *ngIf="vendor?.telephoneNumber"
              data-cy="vendor-phone-number-text"
            >
              {{ vendor?.telephoneNumber }}
            </p>
            <p *ngIf="vendor?.email" data-cy="vendor-email-text">
              {{ vendor?.email }}
            </p>
          </div>
        </ion-col>
      </ion-row>
    </ng-container>

    <!-- NO RESULTS -->
    <section
      *ngIf="vendorData?.vendors?.length === 0"
      class="search-result-not-found"
    >
      <span
        class="search-result-title"
        data-cy="no-search-results-text"
        [ngClass]="(platformService.platformType === platformService.platformEnum.mobile) ? 'mobile' : ''"
      >
        {{ 'i18n.nonUsfProducts.noVendorFound' | translate }}
      </span>
      <span
        class="search-result-subtitle"
        data-cy="select-new-vendor-text"
        [ngClass]="(platformService.platformType === platformService.platformEnum.mobile) ? 'mobile' : ''"
      >
        {{ 'i18n.vendors.selectAddNewVendor' | translate }}
      </span>
    </section>
  </ion-grid>

  <!-- Desktop Sticky Footer for Delete/Edit -->
  <ng-container *ngIf="(platformService?.isTouchExperience$ | async) === false">
    <!-- Desktop Sticky Footer for Delete/Edit -->
    <app-manage-vendors-sticky-footer
      [externalVendorData]="vendorData"
      (deleteEvent)="openDeleteModal()"
    >
    </app-manage-vendors-sticky-footer>

    <app-footer></app-footer>
  </ng-container>
</ion-content>

<!-- Tablet/Mobile Sticky Footer for Delete/Edit -->
<app-manage-vendors-sticky-footer
  *ngIf="(platformService?.isTouchExperience$ | async) && (vendorData$ | async) as vendorData"
  [externalVendorData]="vendorData"
  (deleteEvent)="openDeleteModal()"
>
</app-manage-vendors-sticky-footer>

<!-- Add Vendor Button for Mobile -->
<div
  class="add-new-vendor-moblie"
  *ngIf="platformService.platformType === platformService.platformEnum.mobile && (vendorData$ | async) as vendorData"
>
  <ion-button
    *ngIf="vendorData?.numSelectedVendors < 1"
    id="create-non-usf-vendor-btn"
    data-cy="create-non-usf-vendor-button"
    class="usf-fill-green-button"
    type="submit"
    (click)="openCreateNonUsfVendorModal(ListActions.create, vendorData)"
  >
    {{ 'i18n.vendors.addNewVendor' | translate }}
  </ion-button>
</div>

<ion-modal
  [isOpen]="externalVendorService.deleteVendorModalSubject.value"
  (ionModalDidDismiss)="handleDeleteDismiss()"
  [initialBreakpoint]="
      this.platformService.platformType !==
      this.platformService.platformEnum.desktop
        ? 1
        : undefined
    "
  [breakpoints]="
      this.platformService.platformType !==
      this.platformService.platformEnum.desktop
        ? [0, 1]
        : undefined
    "
  [ngClass]="
      (this.platformService?.isTouchExperience$ | async)
        ? 'ion-modal-touch'
        : 'delete-item-non-usf-modal-desktop'
    "
>
  <ng-template>
    <app-delete-items-confirmation-modal
      *ngIf="(vendorData$ | async ) as vendorData"
      class="ion-page"
      [platform]="this.platformService.platformType"
      [isTouch]="this.platformService?.isTouchExperience$ | async"
      [totalSelected]="vendorData?.numSelectedVendors"
      [additionalWarning]="'i18n.vendors.deleteVendorsWarning'"
      [isWarning]="false"
      [singular]="'i18n.vendors.vendor'"
      [plural]="'i18n.vendors.vendors'"
      (submitEvent)="handleDeleteSubmit(vendorData)"
      (dismissEvent)="handleDeleteDismiss()"
    >
    </app-delete-items-confirmation-modal>
  </ng-template>
</ion-modal>
